export function convertBooleanObjectToString(
  obj: Record<string, unknown> | undefined,
): Record<string, string> {
  if (!obj) return {}

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, String(value ?? false)]),
  )
}
